import * as http from '@/api/config';

export function get(url, data) {
    return http.$get(url, data);
}

export function post(url, data) {
    return http.$post(url, data);
}


/* 获取系统信息 */
export function getAppInfo(data) {
	const url = 'system/home/v1/system/info';
	return http.$post(url, data);
}

/* 获取系统背景图 */
export function getBackground(data) {
	const url = "background";
	return http.$get(url, data);
}
/* 获取日志列表 */
export function getLogList(data) {
    const url = "sysyem/admin/v1/log/list";
    return http.$get(url, data);
}
/* 获取上传OSS参数 */
export function getUploadParam(module) {
    const url = "sysyem/admin/v1/upload/param/" + module;
    return http.$get(url);
}
/* 获取上传OSS参数 */
export function getUserUploadMedia(path) {
    const url = "sysyem/admin/v1/upload/media";
    return http.$get(url, {
        path: path
    });
}
/* 修改oss文件参数 */
export function updateUserMedia(data) {
    const url = "sysyem/admin/v1/upload/update";
    return http.$put(url, data);
}
/* 删除oss文件 */
export function createUserMediaDir(path) {
    const url = "sysyem/admin/v1/upload/create";
    return http.$post(url, {
        path: path
    });
}
/* 删除oss文件 */
export function deleteUserMedia(urls) {
    const url = "sysyem/admin/v1/upload/delete";
    return http.$delete(url, {
        urls: urls
    });
}

/* 获取绑定微信的二维码 */
export function getBindWechatQr() {
    const url = "user/admin/v1/user/wechatQr";
    return http.$get(url, {
        scene: 'bind'
    });
}

/* 上报日志 */
export function reportAdminLog(err, vm, info) {
    console.error(err);
}


// WEBPACK FOOTER //
// ./src/api/module/app.js